// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2MSTs","file":"styles_file__3Cshb"};